import DOMPurify from 'dompurify';
import React from 'react';

type Props = {
  html: string;
  className?: string;
};

export const SafeHtml: React.FC<Props> = ({html, className}) => {
  const sanitized = DOMPurify.sanitize(html);
  return (
    <div className={className} dangerouslySetInnerHTML={{__html: sanitized}} />
  );
};
